import React, { Fragment, useContext } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button, Icon, Popover, Spin } from '../../common/UIComponents';
import InvoicesItemList from './InvoicesItemList';
import AccessorialCharges from '../../containers/AccessorialCharges';
import I18n from '../../common/I18n';
import TransportationChargesList from './TransportationChargesList';
import _ from 'lodash';
import '../../../stylesheets/ChargesSection.scss';
import { UserContext } from '../../context/UserContext';
import InfoIcon from '../../common/CustomIcon';

const ChargesSection = ({
  title = 'charges-section',
  chargeType,
  estimateApiParams = {},
  section,
  locations,
  allLocations = [],
  isTemplateZoneBilling,
  isInvoiceLocked,
  isReadyOnly,
  showActions,
  isOnHold,
  isAdjusted,
  handleAddItem,
  handleItemsChange,
  handleDeleteClick,
  handleInputSaveItem,
  findSectionTotal,
  orderData,
  orderDataWithLocations = {},
  glCodesList,
  handleEditItem,
  handleEditIndvItem= () => {},
  cancelEditItem,
  editSave,
  removeEditingVals,
  removeIndvEditingVals=false,
  // Additional props for specific charge types
  accessorials,
  invoice,
  technicians,
  drivers,
  orgId,
  accountId,
  orderId,
  reqData,
  handleRecordUpdate,
  refreshParentDetails,
  refreshAccessorial,
  orgComponents,
  displayComponents,
  accountComponentAccessorial,
  orderAccessorials,
  authorizeDetails,
  slotConfig,
  // Props for transportation charges
  ikeaChargesrecord,
  updateRecords,
  defaultTransportationChargeGLCode,
  isInvoiceApproved,
  // Props for fuel surcharges
  fuelPercentEdit,
  currentProcessedId,
  fuelPercentSave,
  onFuelPercentChange,
  editedFuelPercent,
  fuelPercentCancel,
  handleKeyDown,
  reapproveBilling,
  isMilitaryTime,
  screenType = "ManageBilling",
  handleOnItemsChange= () => {},
  //Items for expanded line
  onRowExpand = () => {},
  expandedChargeLineData = [],
  expandedRowId = "",
  indvCancelEditItem = () => {},
  findIndvSectionTotal = () => {},
  handleIndvDeleteclick = () => {},
  editIndvSave = () => {},
  handleIndvItemsChange = () => {},
  handleIndvInputSaveItem = () => {},
  handleIndvAddItem = () => {},
  //...
  //No Modify change handler for accessorial charges when invoice is approved and user doesn't have permission to modify
  handleNoModifyChange = () => {},
  //...
  addNewChargeLine
}) => {

  const userContext = useContext(UserContext);
  // Extracting org rules from user context
  const orgrules = _.get(userContext, "orgRules.org_billing_rules", {});
  // Determine if GL codes should be grouped by warehouse
  const groupGlByWarehouseSetting = _.get(orgrules , "group_gl_by_warehouse") === "true";
  // for expandable row...
  const isSingleInvoiceLine = section?.is_single_invoice_line === "true";

const renderExpandIcon = ({ expanded, onExpand, record }) => {
  if (!isSingleInvoiceLine || record?.added_from !== 'AUTO') {
    return null;
  }
  return (
    <Icon
      type={expanded ? 'minus-square' : 'plus-square'}
      onClick={(e) => onExpand(record, e)}
      style={{ cursor: 'pointer' }}
    />
  );
};

  const expandedRowKeys = expandedRowId ? [expandedRowId] : [];

  //...

  const handleAddClick = () => {
    const orderNumber = section?.order_number || orderData?.order_no;
    if (orderNumber) {
      handleAddItem(chargeType, orderNumber, locations);
    }
  };

  const getLocationsForLine = (line) => {
    if (
      ["transportation_charges", "fuel_surcharges", "adjustment_charges"].includes(chargeType)
    ) {
      return allLocations;
    }
    return locations;
  };

  const renderChargesList = () => {
    const commonProps = {
      data: section.price_list || [],
      currentSection: section,
      showActions,
      invoice_type: chargeType,
      handleOnChange: handleItemsChange,
      size: "small",
      pagination: { position: "none" },
      deleteClick: handleDeleteClick,
      saveItem: handleInputSaveItem,
      totalRecords: section.price_list?.length || 0,
      addItem: handleAddItem,
      showAddIcon: !isReadyOnly && !isInvoiceLocked && !isOnHold && addNewChargeLine,
      isReadyOnly,
      isLocked: isInvoiceLocked || isOnHold || orderData.is_locked === "true",
      hasNew: section.price_list?.filter((item) => item.isNew === true).length === 0,
      groupGlByWarehouseSetting,
      footer: () => (
        <div className="subtotal-row">
          <span className="subtotal-label">{I18n.t("invoices.sub_total")}:</span>
          <span className="subtotal-amount">
            {findSectionTotal(chargeType, section?.order_number || orderData?.order_no)}
          </span>
        </div>
      ),
      orderData,
      orderDataWithLocations,
      screenType,
      glCodesList,
      showEditIcon: true,
      handleEditItem,
      cancelEditItem,
      editSave : editSave,
      removeEditingVals,
      removeIndvEditingVals,
      type_of_order: section.type_of_order || orderData.type_of_order,
      defaultTransportationChargeGLCode: defaultTransportationChargeGLCode || "",
      handleEditIndvItem,
      indvCancelEditItem,
      onNoModifyChange: handleNoModifyChange,
      getLocationsForLine: (line) => getLocationsForLine(line),
    };

        const indvCommonProps = {
      data: section.individual_lines || [],
      currentSection: section,
      showActions,
      invoice_type: chargeType,
      handleOnChange: handleIndvItemsChange,
      size: "small",
      pagination: { position: "none" },
      deleteClick: handleIndvDeleteclick,
      saveItem: handleIndvInputSaveItem,
      totalRecords: section.individual_lines?.length || 0,
      addItem: handleIndvAddItem,
      showAddIcon: !isReadyOnly && !isInvoiceLocked && !isOnHold && addNewChargeLine,
      isReadyOnly,
      isLocked: isInvoiceLocked || isOnHold || orderData.is_locked === "true",
      hasNew: section.individual_lines?.filter((item) => item.isNew === true).length === 0,
      groupGlByWarehouseSetting,
      footer: () => (
        <div className="subtotal-row">
          {/* <span className="subtotal-label">{I18n.t("invoices.sub_total")}:</span>
          <span className="subtotal-amount">
            {findIndvSectionTotal(chargeType, section?.order_number || orderData?.order_no)}
          </span> */}
        </div>
      ),
      orderData,
      orderDataWithLocations,
      screenType,
      glCodesList,
      showEditIcon: true,
      handleEditItem,
      cancelEditItem,
      editSave : editIndvSave,
      removeEditingVals,
      removeIndvEditingVals,
      type_of_order: section.type_of_order || orderData.type_of_order,
      defaultTransportationChargeGLCode: defaultTransportationChargeGLCode || "",
      handleEditIndvItem,
      indvCancelEditItem,
      onNoModifyChange: handleNoModifyChange,
      dataTestId: title.trim().toLowerCase().replace(/\s+/g, '-'),
      getLocationsForLine: (line) => getLocationsForLine(line),
    };

    if (chargeType === "accessorial_charges") {
      const sortedPriceList = _.sortBy(section.price_list, [(item) => (item?.invoice_name ? item.invoice_name : -1)]) || [];
      return (
        <AccessorialCharges
          {...commonProps}
          isAdjusted={isAdjusted}
          reapproveBilling={reapproveBilling}
          estimateApiParams={estimateApiParams}
          invoice={invoice}
          accessorials={accessorials}
          bordered={true}
          isMilitaryTime={isMilitaryTime}
          technicians={technicians}
          drivers={drivers}
          orgId={orgId}
          accountId={accountId}
          orderId={orderId}
          reqData={reqData}
          orgrules={orgrules}
          data={sortedPriceList}
          handleRecordUpdate={(record, index, currentOrderNo) => handleRecordUpdate(record, index, section.order_number)}
          refreshParentDetails={refreshParentDetails}
          refreshAccessorial={refreshAccessorial}
          orgComponents={orgComponents}
          displayComponents={displayComponents}
          accountComponentAccessorial={accountComponentAccessorial}
          orderAccessorials={orderAccessorials}
          authorizeDetails={authorizeDetails}
          slotConfig={slotConfig}
          handleOnItemsChange={handleOnItemsChange}
        />
      );
    } else if (isTemplateZoneBilling && chargeType === 'transportation_charges') {
      return (
        <TransportationChargesList
          {...commonProps}
          initializeInputValues
          updateRecords={updateRecords}
          defaultTransportationChargeGLCode={defaultTransportationChargeGLCode}
          isInvoiceApproved={isInvoiceApproved}
          data={ikeaChargesrecord || []}
          initialInputValues={ikeaChargesrecord || []}
          isTemplateZoneBilling={isTemplateZoneBilling}
        />
      );
    } else {
      const expandableConfig =
        isSingleInvoiceLine && !_.isEmpty(section?.individual_lines)
          ? {
              expandedRowKeys: expandedRowKeys,
              onExpand: onRowExpand,
              rowExpandable: (record) =>
                record?.added_from === "AUTO" &&
                !_.isEmpty(section?.individual_lines),
              expandIcon: renderExpandIcon,
              expandedRowRender: (record) => {
                if (record?.added_from === "AUTO") {
                  return (
                    <InvoicesItemList
                      key={`expanded-${record.id}`}
                      {...indvCommonProps}
                      size="small"
                      bordered={false}
                      showActions={false}
                      pagination={{ position: "none" }}
                      isSubItemList={true}
                      scroll={{ y: `calc(100vh - 470px)` }}
                      handleKeyDown={handleKeyDown}
                      fuelPercentSave={fuelPercentSave}
                      onFuelPercentChange={onFuelPercentChange}
                      editedFuelPercent={editedFuelPercent}
                      fuelPercentCancel={fuelPercentCancel}
                      fuelPercentEdit={fuelPercentEdit}
                      currentProcessedId={currentProcessedId}
                    />
                  );
                }
              },
            }
          : {};

      return (
        <InvoicesItemList
          {...commonProps}
          {...expandableConfig}
          isAdjusted={isAdjusted}
          bordered={true}
          fuelPercentEdit={fuelPercentEdit}
          currentProcessedId={currentProcessedId}
          fuelPercentSave={fuelPercentSave}
          onFuelPercentChange={onFuelPercentChange}
          editedFuelPercent={editedFuelPercent}
          fuelPercentCancel={fuelPercentCancel}
          handleKeyDown={handleKeyDown}
          isSingleInvoiceLine={isSingleInvoiceLine}
        />
      );
    }
  };

  const canAddItems = (!isInvoiceLocked || (!isReadyOnly && showActions === true)) && !isOnHold && !isAdjusted;

  return (
    <div className="charges-section" data-testid={`${title.trim().toLowerCase().replace(/\s+/g, '-')}-list`}>
      <div className="section-title">
        {title}
        {["transportation_charges", "fuel_surcharges"].includes(chargeType) && section.is_single_segment && (
            <Popover
              content={
                <div className="info-content">
                  <p>{`${_.startCase(chargeType.replace(/_/g, " "))} are split equally per stop, and drivers are paid based on the stops they complete.`}</p>
                </div>
              }
              trigger="hover"
              placement='right'
              mouseEnterDelay={0}
            >
              <span
                className="info-icon"
                style={{ display: 'inline-block', cursor: 'pointer', pointerEvents: 'auto' }}
                role="button"
                tabIndex={0}
              >
                <InfoIcon width="18" height="18" />
              </span>
            </Popover>
        )}
      </div>
      <Row>
        {_.isEmpty(section.price_list) ? (
          <Col xs={24} className="empty-state">
            {canAddItems && (
              <Button
                data-testid={`${title.trim().toLowerCase().replace(/\s+/g, '-')}-add-charges-button`}
                className="add-item-button"
                onClick={handleAddClick}
              >
                <Icon type="plus" />
                {I18n.t(`general.add`)}
              </Button>
            )}
          </Col>
        ) : (
          <Col xs={24}>
            {renderChargesList()}
          </Col>
        )}
      </Row>
    </div>
  );
};

ChargesSection.propTypes = {
  title: PropTypes.string.isRequired,
  chargeType: PropTypes.string.isRequired,
  section: PropTypes.object.isRequired,
  locations: PropTypes.array,
  allLocations: PropTypes.array,
  isTemplateZoneBilling: PropTypes.bool,
  isInvoiceLocked: PropTypes.bool,
  isReadyOnly: PropTypes.bool,
  showActions: PropTypes.bool,
  isOnHold: PropTypes.bool,
  isAdjusted: PropTypes.bool,
  handleAddItem: PropTypes.func.isRequired,
  handleItemsChange: PropTypes.func.isRequired,
  handleDeleteClick: PropTypes.func.isRequired,
  handleInputSaveItem: PropTypes.func.isRequired,
  findSectionTotal: PropTypes.func.isRequired,
  orderData: PropTypes.object.isRequired,
  orderDataWithLocations: PropTypes.object.isRequired,
  screenType: PropTypes.string,
  glCodesList: PropTypes.array,
  handleEditItem: PropTypes.func.isRequired,
  handleEditIndvItem: PropTypes.func.isRequired,
  cancelEditItem: PropTypes.func.isRequired,
  editSave: PropTypes.func.isRequired,
  removeEditingVals: PropTypes.bool,
  removeIndvEditingVals: PropTypes.bool,
  // Item for expanded line
  onRowExpand: PropTypes.func,
  expandedChargeLineData: PropTypes.array,
  expandedRowId: PropTypes.string,
  indvCancelEditItem: PropTypes.func.isRequired,
  findIndvSectionTotal: PropTypes.func.isRequired,
  handleIndvDeleteclick: PropTypes.func.isRequired,
  editIndvSave: PropTypes.func.isRequired,
  handleIndvItemsChange: PropTypes.func.isRequired,
  removeIndvEditingVals: PropTypes.bool,
  handleIndvInputSaveItem: PropTypes.func.isRequired,
  handleIndvAddItem: PropTypes.func.isRequired,
  //...
  //on No modify change checkbox
  handleNoModifyChange: PropTypes.func.isRequired,
  //...
};

export default ChargesSection; 